module.exports = __webpack_public_path__ + "static/media/green-circle-tick.82db2eda.svg";